import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import { reefIconPngSrc } from './reefLogoSrc';

export default function ReefLogoMark({ size = 35, sx }) {
  const theme = useTheme();
  const src = reefIconPngSrc(theme.palette.mode, size);

  return (
    <Box
      component="img"
      src={src}
      alt=""
      aria-hidden
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        display: 'block',
        objectFit: 'contain',
        ...sx
      }}
    />
  );
}
